export const ru = {
  wizard: {
    new: 'Новая',
    stepOf: '{{step}} / {{total}}',
    continue: 'Продолжить',
    draftLoadError: 'Не удалось открыть черновик',
    type: {
      title: 'Что создаём?',
      subscription: 'Регулярная подписка',
      subscriptionSub: 'повторяется каждый период · Netflix, VPN…',
      collection: 'Разовый сбор',
      collectionSub: 'общий расход · подарок, поездка',
    },
    name: {
      title: 'Название и иконка',
      label: 'Название',
      placeholder: 'Netflix Family',
      iconLabel: 'Иконка',
      iconHint: '· авто, нажми чтобы изменить',
      iconAuto: 'Авто из названия',
      iconCustom: 'Своя иконка',
      browse: 'Все иконки ›',
      hide: 'Скрыть',
      autoOption: 'авто',
      pickerTitle: 'Выберите иконку',
      pickerDone: 'Готово',
      pickerSearch: 'Поиск…',
      tabServices: 'Сервисы',
      tabEmoji: 'Эмодзи',
      emojiCatPopular: 'Популярные',
      emojiCatAll: 'Все',
      emojiCatFaces: 'Лица',
      emojiCatPeople: 'Люди',
      emojiCatAnimals: 'Животные',
      emojiCatObjects: 'Объекты',
      emojiCatActivity: 'Активность',
      emojiCatFood: 'Еда',
      emojiCatTravel: 'Путешествия',
      emojiCatNature: 'Природа',
      emojiCatSymbols: 'Символы',
      emojiCatFlags: 'Флаги',
      searchHint: 'Введи название — иконки появятся здесь',
      noResults: 'Ничего не найдено',
      resetIcon: 'Сбросить иконку',
    },
    price: {
      title: 'Цена и расписание',
      totalPrice: 'Общая цена',
      currency: 'Валюта',
      period: 'Периодичность',
      periodSentence: 'Вы платите каждый',
      monthly: 'Ежемес.',
      quarterly: 'Раз в квартал',
      yearly: 'Ежегодно',
      custom: 'Своё',
      monthLabel: 'месяц',
      quarterLabel: 'квартал',
      yearLabel: 'год',
      customLabel: 'своё...',
      every: 'каждые',
      chargeDate: 'Дата оплаты подписки',
      chargeDateTooltip: 'Дата списания средств с вас и первая дата, с которой с других участников требуется совместная оплата.',
      selectDate: 'Выбрать',
      calTitle: 'Дата оплаты подписки',
      payBy: 'Оплатить',
      deadlineSame: 'в день подписки',
      deadlineBefore: 'перед днём подписки',
      deadlineCustom: 'другое',
      deadlineDays: 'дней',
      deadlineBef: 'перед',
      deadlineAft: 'после',
      deadlineOf: 'оплаты',
      hint: 'Дедлайн по умолчанию совпадает с датой списания. Участники могут платить за несколько периодов вперёд.',
      days: 'дней',
      weeks: 'недель',
      months: 'месяцев',
    },
    collect: {
      title: 'Сбор',
      sentence: 'Участникам подписки нужно оплатить свою часть',
    },
    split: {
      title: 'Как делим?',
      equal: 'Поровну',
      proportional: 'Неравно',
      fixed: 'Точная ₽',
      equalInfo: 'Общая сумма делится поровну между всеми участниками при вступлении.',
      proportionalInfo: 'Каждый участник указывает свою долю — сумма будет пересчитана пропорционально.',
      addMember: 'Добавить участника',
      namePlaceholder: 'Имя',
      sumEqual: 'Сумма {{sum}} = итого',
      sumNotEqual: 'Сумма {{sum}} ≠ итого {{total}}',
    },
    members: {
      title: 'Участники',
      youHolder: 'Вы — держатель',
      holderFallback: 'Я',
      inviteTitle: 'Пригласительная ссылка',
      inviteAfterCreate: 'Ссылка появится сразу после создания',
      inviteNote: 'Добавляйте всех участников и возвращайтесь сюда',
      copy: 'Скопировать',
      copied: 'Скопировано!',
      privacyLabel: 'Участники видят',
      everyone: 'Все',
      everyoneDesc: 'участники видят суммы друг друга',
      countOnly: 'Только количество',
      countOnlyDesc: 'участники видят лишь число плательщиков',
      nobody: 'Никто',
      nobodyDesc: 'только держатель видит данные',
      default: 'по умолчанию',
      showHistory: 'Показывать историю новым участникам',
      allHere: 'Все на месте → делим',
    },
    preview: {
      title: 'Предпросмотр',
      totalPerPeriod: 'Итого в период',
      chargeDate: 'Дата списания',
      splitMode: 'Разделение',
      privacy: 'Видимость',
      perMember: 'Доли участников',
      memberFallback: 'Участник {{n}}',
      error: 'Ошибка создания. Попробуйте ещё раз.',
      create: 'Создать и уведомить',
      saveDraft: 'Сохранить как черновик',
    },
  },
  settings: {
    title: 'Настройки',
    language: 'Язык',
    languageRu: 'Русский',
    languageEn: 'English',
    placeholder: 'Уведомления и приватность — в следующих фазах',
    notifications: 'Уведомления',
    notificationsHint: 'Каждая подписка сможет переопределить эти правила.',
    events: {
      charge_created: 'Новое начисление',
      reminder: 'Напоминание о долге',
      price_changed: 'Изменение цены',
      payment_marked: 'Участник отметил оплату',
      payment_confirmed: 'Оплата подтверждена',
      payment_rejected: 'Оплата отклонена',
      receipt_requested: 'Запрошен чек',
      receipt_uploaded: 'Чек загружен',
      exit_request_received: 'Запрос на выход',
      exit_approved: 'Выход одобрен',
      exit_declined: 'Выход отклонён',
      manual_correction_created: 'Ручная корректировка',
      operation_reversed: 'Операция отменена',
      subscription_closed: 'Подписка закрыта',
      subscription_paused: 'Подписка приостановлена',
      subscription_resumed: 'Подписка возобновлена',
      invite_accepted: 'Приглашение принято',
      member_force_removed: 'Участник удалён',
      participant_unreachable: 'Участник недоступен',
    },
  },
  common: {
    loading: 'Загрузка…',
    error: 'Ошибка',
    retry: 'Повторить',
    back: 'Назад',
    close: 'Закрыть',
    done: 'Готово',
    delete: 'Удалить',
    dash: '—',
    rub: '₽',
    currentPeriod: 'текущий период',
    overdue: 'просрочено',
    today: 'сегодня',
    tomorrow: 'завтра',
    daysShort: '{{count}} дн.',
    periodMonthsShort: 'мес',
    periodWeeksShort: 'нед',
    periodDaysShort: 'дн',
    periodEveryMonthsShort: 'каждые {{count}} мес.',
    periodEveryWeeksShort: 'каждые {{count}} нед.',
    periodEveryDaysShort: 'каждые {{count}} дн.',
    open: 'Открыть {{name}}',
  },
  navigation: {
    home: 'Главная',
    create: 'Создать',
    settings: 'Настройки',
  },
  calendar: {
    months: {
      jan: 'Январь',
      feb: 'Февраль',
      mar: 'Март',
      apr: 'Апрель',
      may: 'Май',
      jun: 'Июнь',
      jul: 'Июль',
      aug: 'Август',
      sep: 'Сентябрь',
      oct: 'Октябрь',
      nov: 'Ноябрь',
      dec: 'Декабрь',
    },
    weekdays: {
      mon: 'Пн',
      tue: 'Вт',
      wed: 'Ср',
      thu: 'Чт',
      fri: 'Пт',
      sat: 'Сб',
      sun: 'Вс',
    },
  },
  home: {
    roles: {
      member: 'Участник',
      holder: 'Держатель',
    },
    totalDebt: {
      clearTitle: 'Всё оплачено',
      dueTitle: 'Всего к оплате',
      clearHint: 'Нет активных долгов',
      nearestDeadline: 'Ближайший дедлайн · {{date}}',
      periodDebt: 'Долги за текущий период',
    },
    collectionBadge: 'сбор',
    empty: {
      holderTitle: 'Создайте первую подписку',
      memberTitle: 'Нет активных подписок',
      holderText: 'Добавьте участников и начните собирать оплаты',
      memberText: 'Примите приглашение от держателя подписки',
      create: 'Создать подписку',
    },
    holder: {
      totalMonthly: 'Итого ежемесячно',
      subscriptionsCount: '{{count}} подписки',
      drafts: 'Черновики',
      active: 'Активные',
      attention: 'Требует внимания',
    },
    member: {
      subscriptions: 'Подписки',
      collections: 'Сборы',
      welcomeBack: 'С возвращением',
      loadError: 'Не удалось загрузить подписки',
    },
  },
  subscription: {
    title: 'Подписка',
    collectionTitle: 'Сбор',
    archiveTitle: 'Архив',
    historyTitle: 'История',
    paymentsTitle: 'Оплаты',
    status: {
      active: 'active',
      draft: 'черновик',
      paused: 'пауза',
      closing: 'закрывается',
      closed: 'закрыта',
    },
    actions: {
      remindAll: 'Remind all',
      changePrice: 'Change price',
      addMember: 'Add member',
      more: '···',
      close: 'Закрыть подписку',
      settings: 'Настройки подписки',
    },
    tabs: {
      members: 'Members',
      finance: 'Finance',
      events: 'Events',
    },
    membersEmpty: 'Нет участников',
    financeComingSoon: 'История операций появится в следующем обновлении',
    eventsComingSoon: 'Лента событий появится в следующем обновлении',
    loadError: 'Не удалось загрузить подписку',
    membersCountShort: '{{count}} участн.',
    billingDate: 'Дата списания: {{date}}',
    periodMonthly: 'ежемесячно',
    periodQuarterly: 'раз в квартал',
    periodYearly: 'ежегодно',
    memberRow: {
      paid: 'paid',
      credit: '+{{amount}} {{currency}} credit',
      holder: 'holder',
      noBot: 'no bot',
      blocked: 'blocked',
      exit: 'exit?',
    },
    memberCard: {
      paid: 'paid',
      pending: 'pending',
      overdue: 'overdue',
      due: 'due',
      draft: 'черновик',
      paidAmount: 'Paid · 0 {{currency}}',
      allClear: 'all clear',
      waitingHolder: 'waiting for holder',
      currentDebt: 'current period debt',
      draftHint: 'держатель ещё настраивает подписку',
      iPaid: 'Я оплатил',
    },
    memberDetail: {
      balance: 'Ваш баланс',
      left: 'осталось',
      due: 'дедлайн {{date}}',
      private: 'это видите только вы',
      operations: 'Операции',
      history: 'История',
      historyPrivacy: 'Вы не видите чужие долги, оплаты и чеки.',
      finalInvoice: 'Подписка закрыта. Оставшийся долг сохранён как финальный счёт — его нужно закрыть напрямую с держателем.',
      draftHint: 'Держатель ещё настраивает подписку. Дождитесь, пока он закончит — тогда появится сумма к оплате.',
      requestExit: 'Запросить выход из подписки',
      exitSent: 'Запрос выхода отправлен',
    },
    draft: {
      price: 'цена',
      members: 'участники',
      collect: 'условия',
      split: 'деление',
      preview: 'проверка',
      fallback: 'настройка',
      label: 'Черновик · {{step}} →',
      delete: 'Удалить черновик',
    },
    inviteLink: {
      active: 'Invite link · active',
      none: 'No active invite link',
      copy: 'Copy',
      copied: 'Copied!',
      revoke: 'Revoke',
    },
  },
  subscriptionSettings: {
    title: 'Настройки подписки',
    confirmationMode: 'Требовать подтверждение оплат',
    confirmationModeHint: 'Долг закрывается только после того, как вы подтвердите оплату',
    reminderOffsets: 'Напоминания (дней до/после дедлайна)',
    invalidOffsets: 'Введите числа через запятую, например -3,0,3',
    save: 'Сохранить',
    saved: 'Сохранено',
    error: 'Не удалось сохранить настройки',
    notificationsTitle: 'Уведомления по этой подписке',
  },
  remind: {
    sent: 'Напоминание отправлено {{count}} участникам',
    noDebtors: 'Нет должников для напоминания',
    error: 'Не удалось отправить напоминания',
  },
  invitation: {
    title: 'Приглашение',
    invitedTo: "You're invited to",
    fromHolder: 'from {{name}} · holder',
    payBy: 'Pay by',
    split: 'Split',
    youWillSee: "You'll see",
    pastHistory: 'Past history',
    invalidTitle: 'Ссылка недействительна',
    invalidText: 'Возможно, приглашение уже использовано или отозвано',
    home: 'На главную',
    acceptError: 'Не удалось принять приглашение. Попробуйте ещё раз.',
    accept: 'Принять',
    decline: 'Отклонить',
    periodWeek: '/ week',
    periodWeeks: '/ {{count}} weeks',
    periodMonth: '/ month',
    periodQuarter: '/ quarter',
    periodYear: '/ year',
    periodMonths: '/ {{count}} months',
    periodCustom: '/ {{count}} {{unit}}',
    splitEqual: 'equal share',
    splitProportional: 'proportional',
    splitFixed: 'fixed amount',
    privacyEveryone: '{{count}} members (all visible)',
    privacyOneEveryone: '1 member (all visible)',
    privacyCountOnly: '{{count}} members (count only)',
    privacyOneCountOnly: '1 member (count only)',
    privacyNobody: 'hidden',
    deadlineSame: 'on billing date',
    deadlineAfter: '{{count}} days after billing date',
    deadlineOneAfter: '1 day after billing date',
    deadlineBeforeMonthly: 'the {{day}}th, monthly',
    visible: 'visible',
    hidden: 'hidden',
  },
  payment: {
    receiptDebt: 'CURRENT DEBT',
    resultPendingTitle: 'Отправлено держателю',
    resultSuccessTitle: 'Оплата отмечена',
    pendingBadge: 'Нужно подтверждение',
    successBadge: 'Готово · {{amount}}',
    pendingText: 'Держатель увидит оплату и подтвердит её. Ты получишь уведомление после проверки.',
    successText: '{{name}}: баланс обновлён, долг за текущий период закрыт.',
    showBalance: 'Показать баланс',
    confirmTitle: 'Отметить оплату?',
    submitError: 'Не удалось отправить оплату. Проверь сеть и попробуй ещё раз.',
    commentPlaceholder: 'Комментарий (необязательно)',
    paidFull: 'Да, я оплатил {{amount}}',
    otherAmount: 'Другая сумма',
    hideComment: 'Убрать комментарий',
    addComment: 'Добавить комментарий',
    customTitle: 'Введите сумму',
    fullAmount: 'Ввести полную сумму · {{amount}}',
    partialHint: '{{amount}} < {{full}} — остаток останется долгом.',
    overpayHint: '{{amount}} > {{full}} — переплата уйдёт в баланс.',
    networkError: 'Ошибка сети. Нажми ещё раз, чтобы повторить.',
    confirmAmount: 'Подтвердить {{amount}}',
    confirmation: {
      attention: 'ожидает подтверждения',
      title: 'Оплата · {{name}}',
      confirm: 'Деньги пришли',
      reject: 'Отклонить',
      receipt: 'Запросить чек',
      viewReceipt: '🔍 Просмотреть чек',
      receiptTelegramOnly: 'Этот чек можно посмотреть только в Telegram-боте',
      error: 'Не удалось выполнить действие. Попробуйте ещё раз.',
    },
  },
  payments: {
    filters: {
      all: 'Все',
      payments: 'Оплаты',
      charges: 'Начисления',
      corrections: 'Коррекции',
    },
    empty: 'Операций пока нет',
  },
  archive: {
    hint: 'Закрытые подписки и сборы доступны только для чтения. История сохраняется.',
    empty: 'Архив пока пуст',
    finalBalance: 'Финальный баланс',
  },
  operation: {
    loading: 'Загружаем операции…',
    loadError: 'Не удалось загрузить операции',
    empty: 'Операций пока нет',
    types: {
      charge: 'Начисление',
      final_charge: 'Финальный счёт',
      payment: 'Оплата',
      partial_payment: 'Частичная оплата',
      credit_application: 'Зачёт переплаты',
      charity_transfer: 'Перенос переплаты',
      writeoff: 'Списание долга',
      correction: 'Корректировка',
      reversal: 'Отмена операции',
    },
  },
  event: {
    loading: 'Загружаем события…',
    loadError: 'Не удалось загрузить события',
    empty: 'Событий пока нет',
    holderHint: 'Полный системный лог — виден только держателю',
    types: {
      subscription_created: 'Подписка создана',
      subscription_closed: 'Подписка закрыта',
      subscription_paused: 'Подписка поставлена на паузу',
      subscription_resumed: 'Подписка возобновлена',
      invite_created: 'Создана пригласительная ссылка',
      invite_accepted: 'Приглашение принято',
      invite_declined: 'Приглашение отклонено',
      member_joined: 'Участник присоединился',
      member_exited: 'Участник вышел',
      member_force_removed: 'Участник удалён',
      payment_marked: 'Оплата отмечена',
      payment_confirmed: 'Оплата подтверждена',
      payment_rejected: 'Оплата отклонена',
      billing_period_created: 'Создан расчётный период',
      price_changed: 'Цена изменена',
      exit_requested: 'Запрошен выход',
      exit_approved: 'Выход подтверждён',
      exit_declined: 'Выход отклонён',
      receipt_requested: 'Запрошен чек',
      receipt_uploaded: 'Чек загружен',
      manual_correction_created: 'Создана ручная корректировка',
      operation_reversed: 'Операция отменена',
    },
  },
  management: {
    scenario: {
      today: 'Сегодня',
      currentPeriod: 'Текущий период',
      nextPeriod: 'Следующий период',
      specificDate: 'Конкретная дата',
    },
    changePrice: {
      title: 'Изменить цену',
      newPrice: 'Новая цена',
      applyFrom: 'Применить с',
      preview: 'Изменение применится с {{date}}. Участники получат уведомление.',
      submit: 'Применить и уведомить',
      error: 'Не удалось изменить цену',
    },
    close: {
      title: 'Закрыть подписку',
      lastDay: 'Последний активный день',
      periodEnd: 'Конец периода',
      custom: 'Своя дата',
      preview: 'После закрытия подписка уйдёт в архив. История и финальные балансы сохранятся.',
      finalBalances: 'Финальные балансы',
      submit: 'Закрыть и архивировать',
      error: 'Не удалось закрыть подписку',
    },
    member: {
      title: 'Участник',
      balance: 'Баланс · {{name}}',
      exitRequested: 'запрос выхода',
      adjust: 'Корректировка',
      remove: 'Удалить участника',
      exitApprove: 'Одобрить выход',
      exitDecline: 'Отклонить выход',
    },
    correction: {
      title: 'Скорректировать баланс',
      typeWriteoff: 'Списание долга',
      typeCorrection: 'Корректировка',
      directionIncrease: 'Увеличить долг',
      directionDecrease: 'Уменьшить долг',
      amount: 'Сумма',
      comment: 'Комментарий (опционально)',
      submit: 'Применить',
      error: 'Не удалось применить корректировку',
    },
    addMember: {
      title: 'Добавить участника',
      invite: 'Пригласительная ссылка',
      hint: 'Скопируйте ссылку и отправьте её новому участнику. После принятия он появится в списке.',
    },
    approveExit: {
      title: 'Одобрить выход участника',
      exitDate: 'Дата выхода',
      scenario: 'Финальный расчёт',
      scenarioProrate: 'Пропорционально дням',
      scenarioSettle: 'Оставить как есть',
      submit: 'Одобрить',
      error: 'Не удалось одобрить выход',
    },
  },
  telegramRequired: {
    title: 'Откройте в Telegram',
    text: 'Это Mini App работает только внутри Telegram',
    openButton: 'Открыть в Telegram',
  },
  pages: {
    archive: 'Архив',
    history: 'История',
    payments: 'Оплаты',
    collection: 'Сбор',
  },
  attachReceipt: {
    title: 'Прикрепить чек',
    hint: 'Загрузите фото или PDF подтверждения оплаты',
    pick: 'Выбрать файл',
    submit: 'Отправить',
    success: 'Чек отправлен держателю',
    tooLarge: 'Файл больше 10 МБ',
    error: 'Не удалось загрузить файл',
  },
};

export type Translations = typeof ru;
